import { AnimatePresence, motion } from "motion/react";

function ViewSwitcher({ view, count, onChange }) {
  const onWaitlist = view === "waitlist";

  return (
    <div className="view-switcher-wrap">
      <motion.div
        className="view-switcher"
        role="tablist"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
      >
        <span
          className="view-switcher-pill"
          data-position={onWaitlist ? "waitlist" : "reservations"}
          aria-hidden="true"
        />
        <button
          type="button"
          role="tab"
          aria-selected={!onWaitlist}
          className={`view-switcher-btn ${!onWaitlist ? "active" : ""}`}
          onClick={() => onChange("reservations")}
        >
          Reservations
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={onWaitlist}
          className={`view-switcher-btn ${onWaitlist ? "active" : ""}`}
          onClick={() => onChange("waitlist")}
        >
          Waitlist
        </button>
      </motion.div>

      <AnimatePresence>
        {count > 0 && (
          <motion.button
            key="count"
            type="button"
            className={`view-switcher-count ${onWaitlist ? "active" : ""}`}
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.85 }}
            transition={{ duration: 0.18, ease: [0.4, 0, 0.2, 1] }}
            aria-label={`${count} on waitlist — open waitlist`}
            onClick={() => onChange("waitlist")}
          >
            {count}
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}

export default ViewSwitcher;
